var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_53_1788)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_1788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C22.3869 10 24.6761 10.9482 26.364 12.636C28.0518 14.3239 29 16.6131 29 19C29 22.074 27.324 24.59 25.558 26.395C24.6755 27.2869 23.7128 28.0956 22.682 28.811L22.256 29.101L22.056 29.234L21.679 29.474L21.343 29.679L20.927 29.921C20.6445 30.0818 20.325 30.1663 20 30.1663C19.675 30.1663 19.3555 30.0818 19.073 29.921L18.657 29.679L18.137 29.359L17.945 29.234L17.535 28.961C16.423 28.2083 15.3871 27.3489 14.442 26.395C12.676 24.589 11 22.074 11 19C11 16.6131 11.9482 14.3239 13.636 12.636C15.3239 10.9482 17.6131 10 20 10ZM20 12C18.1435 12 16.363 12.7375 15.0503 14.0503C13.7375 15.363 13 17.1435 13 19C13 21.322 14.272 23.36 15.871 24.996C16.5586 25.6919 17.3017 26.3307 18.093 26.906L18.551 27.232C18.699 27.335 18.841 27.431 18.978 27.52L19.368 27.77L19.711 27.979L20 28.148L20.455 27.879L20.822 27.649C21.017 27.525 21.227 27.386 21.449 27.232L21.907 26.906C22.6983 26.3307 23.4414 25.6919 24.129 24.996C25.728 23.361 27 21.322 27 19C27 17.1435 26.2625 15.363 24.9497 14.0503C23.637 12.7375 21.8565 12 20 12ZM20 15C21.0609 15 22.0783 15.4214 22.8284 16.1716C23.5786 16.9217 24 17.9391 24 19C24 20.0609 23.5786 21.0783 22.8284 21.8284C22.0783 22.5786 21.0609 23 20 23C18.9391 23 17.9217 22.5786 17.1716 21.8284C16.4214 21.0783 16 20.0609 16 19C16 17.9391 16.4214 16.9217 17.1716 16.1716C17.9217 15.4214 18.9391 15 20 15ZM20 17C19.4696 17 18.9609 17.2107 18.5858 17.5858C18.2107 17.9609 18 18.4696 18 19C18 19.5304 18.2107 20.0391 18.5858 20.4142C18.9609 20.7893 19.4696 21 20 21C20.5304 21 21.0391 20.7893 21.4142 20.4142C21.7893 20.0391 22 19.5304 22 19C22 18.4696 21.7893 17.9609 21.4142 17.5858C21.0391 17.2107 20.5304 17 20 17Z",
    fill: "#25BCBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_53_1788",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_53_1788"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_53_1788",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_1788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.1e695473525859d6f6684223f37dfd59.svg";
export { ForwardRef as ReactComponent };